import { ReactElement } from 'react';
import {
  FormDataConsumer,
  TabbedForm,
  TextInput,
  maxLength,
  PasswordInput,
  TabbedFormViewProps,
  BooleanInput,
  minLength,
  required,
  useRefresh,
} from 'react-admin';
import SelfPaginatingBulkAction from '../../../Components/SelfPaginatingBulkAction';
import { BILLING_TYPE_CHOICES } from '../utils';

export default function MerchantConfigTab(props: TabbedFormViewProps): ReactElement {
  return (
    <TabbedForm.Tab label="Merchant Config" {...props}>
      <MerchantConfigTabContent />
    </TabbedForm.Tab>
  );
}

function MerchantConfigTabContent(): ReactElement {
  const refresh = useRefresh();

  return (
    <>
      <BooleanInput
        label="Block International Clicks"
        source="attributes.block_international_clicks"
      />
      <BooleanInput label="Enable Price Tracking and Alerts" source="attributes.price_tracking" />
      <FormDataConsumer>
        {({ formData }) => {
          const merchantId = formData?.id as string | undefined;
          const isCreate = merchantId === undefined;
          const billingTypeCode = formData?.attributes?.billing_type_code as number | undefined;
          const isCpcMerchant =
            billingTypeCode === BILLING_TYPE_CHOICES.find((c) => c.name === 'CPC')?.id;
          const hasPersistedMerchantId = merchantId != null;

          return (
            <>
              {!isCreate && hasPersistedMerchantId && (
                <SelfPaginatingBulkAction
                  changeType="delete"
                  resource="price_histories"
                  filter={{
                    equals: {
                      merchant: { id: merchantId },
                    },
                  }}
                  batchSize={50}
                  color="error"
                  confirm={(total) =>
                    `This will permanently delete ${total} price history row(s) for this merchant.`
                  }
                  buttonLabel={(total) => `Delete price history (${total})`}
                  refresh={refresh}
                />
              )}
              <TextInput
                autoComplete="new-password"
                label="Username"
                source="attributes.username"
                validate={isCpcMerchant ? [maxLength(50), required()] : maxLength(50)}
                isRequired={isCpcMerchant}
              />
              <PasswordInput
                autoComplete="new-password"
                label="Password"
                placeholder="**********"
                source="attributes.password"
                validate={isCreate && isCpcMerchant ? [minLength(8), required()] : minLength(8)}
                isRequired={isCreate && isCpcMerchant}
              />
            </>
          );
        }}
      </FormDataConsumer>
      <BooleanInput label="Promote Merchant" source="attributes.is_featured" />
      <TextInput
        fullWidth
        label="UTM Parameters"
        source="attributes.utm_parameters"
        validate={maxLength(150)}
      />
    </>
  );
}
